var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "url(#paint0_linear_6370_129002)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6370_129002)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6589 12.9753C19.7749 11.7333 20.8329 11.1123 21.9977 11.1123C23.1626 11.1123 24.2206 11.7333 26.3366 12.9753L27.6223 13.73C29.6887 14.9428 30.7219 15.5493 31.2884 16.5387C31.8549 17.5281 31.8549 18.7261 31.8549 21.1221V22.8779C31.8549 25.2739 31.8549 26.4719 31.2884 27.4614C30.7219 28.4508 29.6887 29.0572 27.6223 30.2701L26.3366 31.0247C24.2206 32.2667 23.1626 32.8877 21.9977 32.8877C20.8329 32.8877 19.7749 32.2667 17.6589 31.0247L16.3732 30.2701C14.3068 29.0572 13.2736 28.4508 12.7071 27.4614C12.1406 26.472 12.1406 25.274 12.1406 22.8779V21.1221C12.1406 18.7261 12.1406 17.5281 12.7071 16.5387C13.2736 15.5493 14.3068 14.9428 16.3732 13.73L17.6589 12.9753ZM20.7478 16.8567C20.7282 16.1527 21.2935 15.5714 21.9978 15.5714C22.702 15.5714 23.2673 16.1527 23.2478 16.8567L23.0989 22.2147C23.0824 22.811 22.5943 23.2857 21.9978 23.2857C21.4013 23.2857 20.9132 22.811 20.8966 22.2147L20.7478 16.8567ZM21.9978 28.4286C22.9445 28.4286 23.7121 27.6611 23.7121 26.7143C23.7121 25.7675 22.9445 25 21.9978 25C21.051 25 20.2835 25.7675 20.2835 26.7143C20.2835 27.6611 21.051 28.4286 21.9978 28.4286Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6370_129002",
    x1: 0,
    y1: 0,
    x2: 44,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA6B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78818F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6370_129002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.e11a77e3.svg";
export { ForwardRef as ReactComponent };